<template>
  <Modal
    class="tw-translate-y-[-50%]"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :visible="showRef"
    :is-hide-overlay="isHideOverlay"
    :border-radius="'4px'"
    @close="eventCloseModal"
  >
    <ModalHeader
      :title="
        isVerifyOrg
          ? getComponentUiText(
              'app-settings-team-members-add-team-member-title-1',
            )
          : getComponentUiText(
              'app-settings-org-verify-modal-title-verify-new-org-1',
            )
      "
      @close="eventCloseModal"
    />
    <div class="tw-p-10 modal-verify-org">
      <span
        class="tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none tw-capitalize"
        >{{
          getUiText("app-settings-domain-verify-modal-description-title-1")
        }}</span
      >
      <p
        v-if="!isVerifyOrg"
        class="tw-leading-[130%] tw-text-[15px] tw-pt-[10px] tw-mb-0 tw-flex tw-flex-col"
      >
        <span>{{
          getUiText("app-settings-org-verify-modal-description-A-1")
        }}</span>
        <span><VRuntimeTemplate :template="getVerifyDynamicText()" /> </span>
      </p>
      <p v-if="!isVerifyOrg" class="tw-leading-none tw-pt-[10px] tw-mb-0">
        <span class="tw-text-[15px]">
          {{ getUiText("app-settings-org-verify-modal-description-B-1") }}
        </span>
      </p>
      <p
        v-if="isVerifyOrg"
        class="tw-leading-[130%] tw-text-[15px] tw-pt-[10px] tw-mb-0 tw-flex tw-flex-col tw-text-[#231F20]"
      >
        <span>{{
          getComponentUiText(
            "app-settings-team-members-add-team-member-description-1",
            false,
            { firstName, lastName },
          )
        }}</span>
      </p>
      <div
        class="verify-body tw-p-[40px] tw-mt-[40px] tw-rounded tw-border tw-border-solid tw-border-[#EFF0F1]"
      >
        <span class="tw-text-[16px] tw-font-[600] tw-text-[#211F58]">
          {{
            isVerifyOrg
              ? getUiText(
                  "app-settings-team-members-add-team-member-verification-title-1",
                )
              : getUiText("app-settings-org-verify-modal-title-org-verify-1")
          }}
        </span>
        <p class="tw-mt-[10px] tw-text-[15px] tw-mb-0 tw-text-[#231F20]">
          <span>
            <VRuntimeTemplate
              :template="
                isVerifyOrg
                  ? getProcessedUIText(
                      'app-settings-team-members-add-team-member-verification-description-1',
                      dynamicDescriptionTags,
                    )
                  : getProcessedUIText(
                      'app-settings-org-verify-modal-description-1',
                      dynamicDescriptionTags,
                    )
              "
            />
          </span>
        </p>
        <CopyInfo
          class="copy-info-container tw-mt-[25px] tw-pl-[20px] tw-pr-[14px] tw-py-[10px] tw-bg-[#FFFFFF] tw-rounded-md"
          :text="secretKey"
          :style-icon-css="'tw-w-[18px] tw-h-[18px]'"
        />
      </div>
      <BaseForm :enter-event="true" :show="showRef" @on:submit="verifyRequest">
        <div class="button-container tw-flex tw-justify-end tw-mt-[40px]">
          <div v-if="!isVerifyOrg" class="button-container-left tw-flex-1">
            <b-button
              variant="danger"
              class="button-delete tw-bg-[#F7553C] tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
              @click="() => deleteRequest()"
            >
              {{
                getUiText("app-settings-domain-verify-modal-delete-button-1")
              }}
            </b-button>
          </div>
          <div class="button-container-right">
            <b-button
              data-cy="verify-org-modal-submit-button"
              variant="primary"
              class="button-verify tw-bg-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
              type="submit"
            >
              {{
                getUiText(
                  "app-component-assessments-checklists-assessment-details-card-status-3",
                )
              }}
            </b-button>
          </div>
        </div>
      </BaseForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import store from "../../store";
import utilities, { getComponentUiText } from "../../utils/utilities";
import { Ref, computed, ref, watch } from "vue";
import Modal from "../common/modal.vue";
import ModalHeader from "../common/modalHeader.vue";
import CopyInfo from "@/components/common/copyInfo.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import BaseForm from "../common/form/baseForm.vue";

const DEFAULT_MAX_WIDTH_MODAL = 65;

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  orgName: {
    type: String,
    required: true,
  },
  secretKey: {
    type: String,
    required: true,
  },
  isHideOverlay: {
    type: Boolean,
    default: true,
  },
  isVerifyOrg: {
    type: Boolean,
    default: false,
  },
  firstName: {
    type: String,
    required: false,
    default: "",
  },
  lastName: {
    type: String,
    required: false,
    default: "",
  },
});
const emit = defineEmits([
  "update:show",
  "update:reuqest",
  "delete:request",
  "close:modal",
]);

let showRef: Ref<boolean> = ref(props.show);

const dynamicDescriptionTags: any = {
  "app-component-assessments-checklists-assessment-details-card-status-3": {
    openTag: "<span class='tw-font-semibold'>‘",
    closeTag: "’</span>",
  },
};
const getVerifyDynamicText = (): string => {
  const dynamicDomain = `<span class='tw-font-semibold'>${props.orgName}</span>`;
  return getUiText("app-settings-domain-verify-modal-description-B-1")?.replace(
    " {##domainName##}",
    props.orgName ? ` ${dynamicDomain}` : "",
  );
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const eventCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("close:modal");
};

const verifyRequest = async () => {
  eventCloseModal();
  if (!props.isVerifyOrg) {
    emit("update:reuqest");
    return;
  }
};

const deleteRequest = async () => {
  emit("delete:request");
};

const getProcessedUIText = (id: string, tags: any) => {
  return utilities.getProcessedUIText(
    id,
    tags,
    languageSelectedText.value,
    defaultUiText.value,
  );
};
</script>

<style lang="scss">
.verify-body {
  background: rgba(239, 240, 241, 0.5);
  .copy-info-container {
    padding: 14px 20px;
    .text-copy-container {
      width: calc(100% - 22px);
      color: #231f20;
      font-size: 15px;
    }
  }
}
.copy-info-container {
  max-width: 70%;
}

.button-delete {
  line-height: 100%;
  background-color: #f7553c;
  border-color: #f7553c;
}

.button-verify-later {
  line-height: 100%;
  border: 2px solid #387dff;
  background-color: #ffffff;
  color: #387dff !important;
}

.button-verify {
  line-height: 100%;
  background-color: #387dff;
  border-color: #387dff;
}

@media (max-width: 991px) {
  .copy-info-container {
    max-width: fit-content;
  }
}
@media (max-width: 420px) {
  .modal-verify-org {
    .button-container {
      flex-direction: column-reverse;
    }

    .button-container-left {
      margin-top: 10px;
    }
  }
}

@media (max-width: 768px) {
  .modal-verify-org {
    padding: 1.25rem !important;
  }
}
</style>
